export default __webpack_public_path__ + "static/fans-hero-dark-8f8f7301456afc0a64024a3ebfc5c70e.png";